import { render, staticRenderFns } from "./AddEmailConfigurationForm.vue?vue&type=template&id=4bba1995&scoped=true&"
import script from "./AddEmailConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./AddEmailConfigurationForm.vue?vue&type=script&lang=js&"
import style0 from "./AddEmailConfigurationForm.vue?vue&type=style&index=0&id=4bba1995&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba1995",
  null
  
)

export default component.exports